import { registerPlugin } from '@capacitor/core';

export interface AppLifecycleLogPlugin {
  /** Entries the native side buffered while the webview was not alive to record them. */
  getLogs(): Promise<{ logs: string[] }>;

  /** Drops the native buffer, so an entry is only ever forwarded once. */
  clearLogs(): Promise<void>;
}

const AppLifecycleLog = registerPlugin<AppLifecycleLogPlugin>('AppLifecycleLog');

export default AppLifecycleLog;
